document.addEventListener('DOMContentLoaded', function() {
    const track = document.querySelector('.section-slider-track');
    const slides = Array.from(track.children);
    const nextButton = document.querySelector('.next-btn');
    const prevButton = document.querySelector('.prev-btn');
    const dotsContainer = document.querySelector('.section-slider-dots');
    
    // Set slide width based on screen size
    let slideWidth;
    
    function setSlideWidth() {
        if (window.innerWidth <= 768) {
            slideWidth = track.clientWidth; // 1 column on mobile
        } else {
            slideWidth = track.clientWidth / 4; // 4 columns on desktop
        }
        
        slides.forEach(slide => {
            slide.style.width = `${slideWidth}px`;
        });
    }
    
    // Initialize slide width
    setSlideWidth();
    
    // Arrange slides next to each other
    function setSlidePosition(slide, index) {
        slide.style.left = `${slideWidth * index}px`;
    }
    
    slides.forEach(setSlidePosition);
    
    // Move to specific slide
    function moveToSlide(targetIndex) {
        track.style.transform = `translateX(-${targetIndex * slideWidth}px)`;
        currentIndex = targetIndex;
    }
    
    let currentIndex = 0;
    
    // Next button click
    nextButton.addEventListener('click', () => {
        if (currentIndex >= slides.length - getVisibleSlides()) return;
        currentIndex++;
        moveToSlide(currentIndex);
       
    });
    
    // Previous button click
    prevButton.addEventListener('click', () => {
        if (currentIndex <= 0) return;
        currentIndex--;
        moveToSlide(currentIndex);
    });
    
    // Calculate how many slides are visible
    function getVisibleSlides() {
        return window.innerWidth <= 768 ? 1 : 4;
    }
    
    // Handle window resize
    window.addEventListener('resize', () => {
        setSlideWidth();
        slides.forEach(setSlidePosition);
        moveToSlide(currentIndex);
    });
});